import ShiftPatternDetails from './ShiftPatternDetails';

export default ShiftPatternDetails;
